/* tslint:disable */
/* eslint-disable */
/**
 * API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../../common/runtime';
import type { ActionConfig } from './ActionConfig';
import {
  ActionConfigFromJSON,
  ActionConfigFromJSONTyped,
  ActionConfigToJSON,
} from './ActionConfig';

/**
 *
 * @export
 * @interface Condition
 */
export interface Condition {
  /**
   *
   * @type {string}
   * @memberof Condition
   */
  action: ConditionActionEnum;
  /**
   * Parameters provided by user to configure the action
   * @type {ActionConfig}
   * @memberof Condition
   */
  config?: ActionConfig;
  /**
   * list of call/sms states this condition should fire on
   * @type {Array<string>}
   * @memberof Condition
   */
  states?: Array<ConditionStatesEnum>;
}

/**
 * @export
 */
export const ConditionActionEnum = {
  Complete: 'complete',
  Next: 'next',
  Retry: 'retry',
  Flow: 'flow',
  DropVm: 'drop_vm',
} as const;
export type ConditionActionEnum =
  (typeof ConditionActionEnum)[keyof typeof ConditionActionEnum];

/**
 * @export
 */
export const ConditionStatesEnum = {
  CallpowerdialerNoAvailableAgent: 'call:powerdialer_no_available_agent',
  CalloutboundConnected: 'call:outbound_connected',
  CallpowerdialerVmDrop: 'call:powerdialer_vm_drop',
  CallmachineDetected: 'call:machine_detected',
  CallpowerdialerCall: 'call:powerdialer_call',
  Callactive: 'call:active',
  Calloutbound: 'call:outbound',
  Callcancelled: 'call:cancelled',
  Callinbound: 'call:inbound',
  Callmissed: 'call:missed',
  Callanswered: 'call:answered',
  Callabandoned: 'call:abandoned',
  CalluserInitiated: 'call:user_initiated',
  Smsaccepted: 'sms:accepted',
  SmsinvalidDestination: 'sms:invalid_destination',
  SmsinvalidSource: 'sms:invalid_source',
  SmsnoRoute: 'sms:no_route',
  SmsrejectedSpam: 'sms:rejected_spam',
  SmsinternalError: 'sms:internal_error',
  Smsrejected: 'sms:rejected',
  SmsnotSupported: 'sms:not_supported',
  SmstimeOut: 'sms:time_out',
  Smserror: 'sms:error',
  Smsunknown: 'sms:unknown',
  SmsownerNoInternationalMessaging: 'sms:owner_no_international_messaging',
  SmsunregisteredA2pNotAllowed: 'sms:unregistered_a2p_not_allowed',
  SmsownerNotEnoughSmsCredits: 'sms:owner_not_enough_sms_credits',
  SmsownerNotEnoughCredits: 'sms:owner_not_enough_credits',
  SmsmessagingDisabled: 'sms:messaging_disabled',
  SmsownerFreeUser: 'sms:owner_free_user',
  SmscontactMissingNumber: 'sms:contact_missing_number',
  SmscontactIsRoom: 'sms:contact_is_room',
  SmscontactIsSharedLine: 'sms:contact_is_shared_line',
  SmsstaffContact: 'sms:staff_contact',
  SmscompanyAffinity: 'sms:company_affinity',
  SmsnotInFreeCompany: 'sms:not_in_free_company',
  SmsinvalidNumber: 'sms:invalid_number',
} as const;
export type ConditionStatesEnum =
  (typeof ConditionStatesEnum)[keyof typeof ConditionStatesEnum];

/**
 * Check if a given object implements the Condition interface.
 */
export function instanceOfCondition(value: object): value is Condition {
  if (!('action' in value) || value['action'] === undefined) return false;
  return true;
}

export function ConditionFromJSON(json: any): Condition {
  return ConditionFromJSONTyped(json, false);
}

export function ConditionFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): Condition {
  if (json == null) {
    return json;
  }
  return {
    action: json['action'],
    config:
      json['config'] == null ? undefined : ActionConfigFromJSON(json['config']),
    states: json['states'] == null ? undefined : json['states'],
  };
}

export function ConditionToJSON(value?: Condition | null): any {
  if (value == null) {
    return value;
  }
  return {
    action: value['action'],
    config: ActionConfigToJSON(value['config']),
    states: value['states'],
  };
}
